import { Component, OnInit } from '@angular/core';
import { Months } from 'src/app/models/months';
import { DataService } from 'src/app/shared/data/data.service';

@Component({
  selector: 'app-months',
  templateUrl: './months.component.html',
  styleUrls: ['./months.component.css']
})
export class MonthsComponent implements OnInit {

  months: Months[];
  selectedValue: number;
  constructor(private dataService: DataService) {
  }

  ngOnInit() {
    this.getMonth();
  }

  getMonth(): void {
    this.dataService.getMonths().subscribe((months => this.months = months) );
  }

}
